import React, { createContext, useState, useMemo, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  // Load initial data from localStorage
  const [name, setName] = useState(localStorage.getItem("name") || "");
  const [userId, setUserId] = useState(localStorage.getItem("userId") || "");
  const [primaryEmail, setPrimaryEmail] = useState(localStorage.getItem("primaryEmail") || "");
  const [profileUrl, setProfileUrl] = useState(localStorage.getItem("profileUrl") || "");
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole") || "");
  const [lastLogin, setLastLogin] = useState(localStorage.getItem("lastLogin") || "");

  // for student only
  const [isEligible, setIsEligible] = useState(localStorage.getItem("isEligible") === "true");
  const [isVerified, setIsVerified] = useState(localStorage.getItem("isVerified") === "true");
  const [verificationEmail, setVerificationEmail] = useState("");

  // consultant with sales person role
  const [hasSalesPersonRole, setHasSalesPersonRole] = useState(
    localStorage.getItem("hasSalesPersonRole") === "true"
  );
  const [assignedBoardIds, setAssignedBoardIds] = useState(
    JSON.parse(localStorage.getItem("assignedBoardIds") || "[]")
  );

  // Save context values to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("name", name);
  }, [name]);

  useEffect(() => {
    localStorage.setItem("userId", userId);
  }, [userId]);

  useEffect(() => {
    localStorage.setItem("primaryEmail", primaryEmail);
  }, [primaryEmail]);

  useEffect(() => {
    localStorage.setItem("profileUrl", profileUrl);
  }, [profileUrl]);

  useEffect(() => {
    localStorage.setItem("userRole", userRole);
  }, [userRole]);

  useEffect(() => {
    localStorage.setItem("lastLogin", lastLogin);
  }, [lastLogin]);

  useEffect(() => {
    localStorage.setItem("isEligible", isEligible);
  }, [isEligible]);

  useEffect(() => {
    localStorage.setItem("isVerified", isVerified);
  }, [isVerified]);

  useEffect(() => {
    localStorage.setItem("hasSalesPersonRole", hasSalesPersonRole.toString());
  }, [hasSalesPersonRole]);

  useEffect(() => {
    localStorage.setItem("assignedBoardIds", JSON.stringify(assignedBoardIds));
  }, [assignedBoardIds]);

  const contextValue = useMemo(() => ({
    name,
    setName,
    userId,
    setUserId,
    primaryEmail,
    setPrimaryEmail,
    profileUrl,
    setProfileUrl,
    userRole,
    setUserRole,
    lastLogin,
    setLastLogin,
    isEligible,
    setIsEligible,
    isVerified,
    setIsVerified,
    verificationEmail,
    setVerificationEmail,
    hasSalesPersonRole,
    setHasSalesPersonRole,
    assignedBoardIds,
    setAssignedBoardIds,
  }), [name, userId, primaryEmail, profileUrl, userRole, lastLogin, isEligible, isVerified, verificationEmail, hasSalesPersonRole, assignedBoardIds]);

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};
